module.exports = __webpack_public_path__ + "static_portal/img/mobile-landscape-mode.4e58a53e.svg";